import clsx from 'clsx'
import React, {useContext} from 'react'
import {Supplier} from '../../../../../suppliers/core/_models'
import {ProductAvailability, computeEarnings, computeAmount} from '../../../../core/_models'
import {KTIcon} from '@/_metronic/helpers'
import {ProductContext} from '../../../ProductContext'
import {Card} from '@/components/Card'


const TableCard = () => {
  const {
    product,
    setItemForUpdate,
    setAction,
    availability,
    suppliers
  } = useContext(ProductContext)

  if (product === undefined) {
    return (<></>)
  }

  return (
    <Card
      title='Suppliers'
      collapsable={false}
      className='card mb-5 mb-xl-8'
      buttons={[{
        className: 'btn btn-sm btn-color-muted btn-active btn-active-primary active',
        label: 'Add',
        icon: 'plus',
        onClick: () => {
          setItemForUpdate(null)
          setAction('add')
        }
      }]}
    >
      {/* begin::Table container */}
      <div className='table-responsive'>
        {/* begin::Table */}
        <table className='table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3'>
          {/* begin::Table head */}
          <thead>
            <tr className='fw-bold text-muted'>
              <th className='min-w-150px'>Supplier</th>
              <th className='min-w-140px'>Name / SKU</th>
              <th className='min-w-50px text-center'>Discount</th>
              <th className='min-w-50px text-center'>VAT</th>
              <th className='min-w-50px text-start'>Amount</th>
              <th className='min-w-50px text-start'>EXCL. Taxes</th>
              <th className='min-w-50px text-start'>Earnings</th>
              <th className='min-w-100px text-end'>Actions</th>
            </tr>
          </thead>
          {/* end::Table head */}
          {/* begin::Table body */}
          <tbody>
            {availability?.map((item: ProductAvailability, index: number) => {
              const supplier = suppliers.find((s: Supplier) => s._id === item.supplier)
              const priceDigits = supplier?.priceDigits ?? 3
              const netAmount = computeAmount(item, priceDigits)
              const soldPrice =  (product.credits || 0)/ product.currencyRate
              const earnings = computeEarnings(item, soldPrice, priceDigits)
              const grossEarnings = earnings.earnings + earnings.vat
              return (
                <tr key={`pa-${index}`}>
                  {/* Supplier Name */}
                  <td>
                    <span className='text-dark fw-bold fs-6'>
                      {supplier?.name || 'Unknown'}
                    </span>
                  </td>

                  {/* Product name */}
                  <td>
                    <span className='text-dark fw-bold d-block mb-1 fs-6'>
                      {item.name}
                    </span>
                    <span className='text-muted fw-semibold text-muted d-block fs-7'>
                      {item.sku}
                    </span>
                  </td>

                  {/* Product discount */}
                  <td className='text-center'>
                    <span className='text-dark fw-bold fs-6'>
                      {item.pricing.discount}%
                    </span>
                  </td>

                  {/* Product VAT */}
                  <td className='text-center'>
                    <span className={clsx('badge', {
                      'badge-light-danger': item.subjectToVat === false,
                      'badge-light-success': item.subjectToVat === true
                    })}>
                      {item.subjectToVat === true ? 'Yes' : 'No' }
                    </span>
                  </td>

                  {/* Product pricing */}
                  <td className='text-start'>
                    <span className='text-dark fw-bold d-block mb-1 fs-6'>
                      {item.pricing.amount} {item.pricing.currency}
                    </span>
                    <span className='text-muted fw-semibold text-muted d-block fs-7'>
                      {(item.pricing.amount * (100 - item.pricing.discount) / 100).toFixed(priceDigits)} {item.pricing.currency}
                    </span>
                  </td>
                  <td className='text-start'>
                    <span className='text-dark fw-bold d-block mb-1 fs-6'>
                      {netAmount} {item.pricing.currency}
                    </span>

                    <span className='text-muted fw-semibold text-muted d-block fs-7'>
                      VAT {item.pricing.vat}%
                    </span>
                  </td>
                  <td className='text-start'>
                    <span className='text-dark fw-bold d-block mb-1 fs-6'>
                      {grossEarnings.toFixed(4)} {supplier?.currency}
                      <span className='text-muted fw-semibold text-muted fs-7 ps-2'>
                        {((
                          soldPrice * 100
                          /
                          (netAmount)
                        ) - 100).toFixed(2)}%
                      </span>
                    </span>

                    <span
                      className='text-muted fw-semibold text-muted d-block fs-7'
                      title="After apply VAT on earnings"
                    >
                      {earnings.earnings.toFixed(4)} {supplier?.currency} <i>NET</i>
                    </span>
                  </td>
                  <td className='text-end'>
                    <button
                      type="button"
                      className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                      onClick={() => {
                        setItemForUpdate(item)
                        setAction('edit')
                      }}
                    >
                      <KTIcon iconName='pencil' className='fs-3' />
                    </button>
                    <button
                      type="button"
                      className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                    >
                      <KTIcon iconName='trash' className='fs-3' />
                    </button>
                  </td>
                </tr>
              )
            })}
          </tbody>
          {/* end::Table body */}
        </table>
        {/* end::Table */}
      </div>
      {/* end::Table container */}
    </Card>
  )
}

export {TableCard}
